import { ChangeDetectorRef, Component } from '@angular/core';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { KeycloakService } from 'keycloak-angular';
import { NavigationEnd, Router } from '@angular/router';
import { AppServiceService } from './app-service.service';
import { UserDetailsMainModel } from './user-details-model';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TelemetryService } from './telemetry.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  hasAuthenticated = false;
  authenticated: any;
  idleState = "NOT_STARTED";
  countdown?: number = null;
  lastPing?: Date = null;

  openIdleSessionDialog: boolean = false;
  isVisible: boolean = false;
  previousUrl: string;
  constructor(public appService: AppServiceService,
    private router: Router,
    private telemetry: TelemetryService,
    protected readonly keycloak: KeycloakService,
    private idle: Idle, keepalive: Keepalive,
    private cd: ChangeDetectorRef)
     { 
       this.authenticated = this.keycloak.getKeycloakInstance().authenticated
       idle.setIdle(60*30); // how long can they be inactive before considered idle, in seconds
       idle.setTimeout(60); // how long can they be idle before considered timed out, in seconds
       idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); // provide sources that will "interrupt" aka provide events indicating the user is active
   
       // do something when the user becomes idle
       idle.onIdleStart.subscribe(() => {
         this.idleState = "IDLE";
       });
       // do something when the user is no longer idle
       idle.onIdleEnd.subscribe(() => {
         this.idleState = "NOT_IDLE";
         this.countdown = null;
         cd.detectChanges(); // how do i avoid this kludge?
       });
       // do something when the user has timed out
       idle.onTimeout.subscribe(() => {
         // alert('Time out')
         this.idleState = "TIMED_OUT"
         this.appService.logoutNew();
       }
       );
       // do something as the timeout countdown does its thing
       this.idle.onTimeoutWarning.subscribe(
         (countdown) => {
           this.countdown = countdown;
           if(countdown === 1){
            this.appService.logoutNew();
            //  this.keycloak.logout();
            //  this.router.navigate(['/login']);
           }else{
            this.openIdleSessionDialog = true;
           }
           
         }
       );
   
       // set keepalive parameters, omit if not using keepalive
       keepalive.interval(15); // will ping at this interval while not idle, in seconds
       keepalive.onPing.subscribe(() => this.lastPing = new Date()); // do something when it pings
     }

   async ngOnInit() {

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = event.url;
      });;
    var isAuthenticated = await this.appService.isLoggedIn();
    if (isAuthenticated == true) {
      this.hasAuthenticated = true;
      this.appService.isAuthenticated1 = true;
      let userResponse = {
        email: (await this.appService.loadUserProfile()).email,
        displayName: (await this.appService.loadUserProfile()).username,
        token: this.appService.getUserToken(),
        role: this.appService.getLoggedUserRole()
      }
      sessionStorage.setItem('Role', this.appService.getLoggedUserRole())
      this.appService.userSubject.next(userResponse);

      let selectedCust = sessionStorage.getItem('selectedCustomer') != 'undefined' ? JSON.parse(sessionStorage.getItem('selectedCustomer')) : null;
      if (selectedCust) {
        this.appService.selectedCustomerSubject.next(selectedCust);
      }

      let selectedUnt = sessionStorage.getItem('selectedUnit') != 'undefined' ? JSON.parse(sessionStorage.getItem('selectedUnit')) : null;
      if (selectedUnt) {
        this.appService.selectedUnitSubject.next(selectedUnt);
      }

      let currentUser = sessionStorage.getItem('userDetails') != 'undefined' ? JSON.parse(sessionStorage.getItem('userDetails')) : null;
      if (currentUser) {
        this.appService.userDetailsSubject.next(currentUser);
      }

      this.appService.getUserDetails(userResponse.email).subscribe(async (data: UserDetailsMainModel) => {
        this.appService.userDetailsSubject.next(data);
        this.telemetry.setUser(String(data?.usersData?.userId));
        sessionStorage.setItem('userDetails', JSON.stringify(data))
        // validate customer
        if (data?.customers?.length == 0) {
          // unauthorized

        }
        if (data?.units?.length == 0) {
          // unauthorized

        }

        if (this.CheckUrl()) {
          if (await this.appService.getUserAccessLevel() == 1) {
            this.router.navigateByUrl('/product-admin');
          }
          else if (await this.appService.getUserAccessLevel() == 2 || await this.appService.getUserAccessLevel() == 6) {
            this.appService.selectedCustomerSubject.next(data.customers[0]);
            sessionStorage.setItem('selectedCustomer', JSON.stringify(data.customers[0]))
            this.router.navigateByUrl('/customer-admin');
          }
          else if (await this.appService.getUserAccessLevel() == 3) {
            this.appService.selectedCustomerSubject.next(data.customers[0]);
            this.appService.selectedUnitSubject.next(data.units[0]);
            this.telemetry.setContext({ unitId: String(data.units[0].id) });
            sessionStorage.setItem('selectedCustomer', JSON.stringify(data.customers[0]))
            sessionStorage.setItem('selectedUnit', JSON.stringify(data.units[0]))
            this.router.navigateByUrl('/user-module');
          }
          else if (await this.appService.getUserAccessLevel() == 4) {
            this.appService.selectedCustomerSubject.next(data.customers[0]);
            sessionStorage.setItem('selectedCustomer', JSON.stringify(data.customers[0]))
            if (data.units?.length == 1) {
              this.appService.selectedUnitSubject.next(data.units[0]);
              this.telemetry.setContext({ unitId: String(data.units[0].id) });
              sessionStorage.setItem('selectedUnit', JSON.stringify(data.units[0]))
              this.router.navigateByUrl('/user-module');
            } else {
              this.router.navigateByUrl('/user-module/kpi-comparison/kpi-dashboard');
            }
          }
          else {
            this.router.navigate(["/"]);
          }
        }
      },
        error => {
          this.router.navigate(["/"]);
        });
    }
    else {
      this.router.navigate(["/"]);
      this.hasAuthenticated = false;
      this.appService.isAuthenticated1 = false;
    }

    this.reset();
  }

  reset() {
    // we'll call this method when we want to start/reset the idle process
    // reset any component state and be sure to call idle.watch()
    this.idle.watch();
    this.idleState = "NOT_IDLE";
    this.countdown = null;
    this.lastPing = null;
  }
  over() {
    this.closeSession();
  }
  closeSession() {
    this.isVisible = false;
    this.reset();
  }
  ngOnDestroy(): void {
    this.isVisible = false;
  }
  stayLoggedIn() {
    this.keycloak.updateToken(5);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    this.idle.watch();
    this.openIdleSessionDialog = false;
  }

  endSession() {
    this.openIdleSessionDialog = false;
    this.keycloak.logout();
  }

  CheckUrl() {
    if (environment.AppName == "") {
      if (window.location.href == window.location.origin + '/' + 'main-shared') {
        return true;
      }
      else {
        return false;
      }
    }
    else if (environment.AppName != "") {
      if (window.location.href == window.location.origin + '/' + environment.AppName + '/main-shared') {
        return true;
      }
      else {
        return false;
      }
    }
    return false;
  }
}
